function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.499 7.963a3.334 3.334 0 10-.998 0A.523.523 0 007.5 8v4a.5.5 0 001 0V8l-.001-.037zm-3.73 1.86a.5.5 0 10-.205-.979c-1.141.24-2.055.616-2.694 1.113-.647.503-1.037 1.152-1.037 1.897 0 .56.271 1.05.671 1.449.398.396.948.73 1.587 1 1.282.541 3.018.864 4.909.864s3.627-.323 4.908-.864c.64-.27 1.19-.604 1.588-1 .4-.399.67-.889.67-1.45 0-.744-.39-1.393-1.036-1.896-.64-.497-1.553-.874-2.694-1.113a.5.5 0 10-.205.979c1.053.22 1.807.552 2.285.924.471.366.65.747.65 1.107 0 .216-.101.466-.376.74-.277.277-.704.549-1.27.788-1.132.477-2.73.785-4.52.785-1.79 0-3.388-.308-4.52-.785-.566-.239-.993-.51-1.27-.787-.275-.275-.377-.525-.377-.741 0-.36.18-.741.65-1.107.479-.372 1.232-.703 2.286-.924z",
  fill: "#0063E3"
});

var SvgPinFilled = function SvgPinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgPinFilled;